const PermissionTypes = {
  RUN_QUOTE:'RunQuotes',
  SUBMIT_TICKET:'SubmitDropTicket',
  VIEW_CASE_STATUS: 'ViewCaseStatus',
  VIEW_CASE_STATUS_ADMIN: 'ViewCaseStatusAdmin'
}

export default PermissionTypes;


// WEBPACK FOOTER //
// ./src/constants/PermissionTypes.js